// Note from copying over from Aphrodite
// Suboptimal solution, but since we currently inject the google tag manager snippet via `createHtmlSkeleton`, reloading the page is necessary at the moment
export default function handleLocationReload() {
  window.location.reload()
}
